import { ChevronLeft } from '@gds/Icons/Paths/ChevronLeft';
import { PlusCircle } from '@gds/Icons/Paths/PlusCircle';
import { Search } from '@gds/Icons/Paths/Search';
import { Input } from '@gds/Input/Input';

import styles from './SearchInput.module.css';

type SearchInputProps = {
  handleSearchChange: (value: string) => void;
  searchValue: string;
  placeholder: string;
  isSearching: boolean;
  searchIsActive: boolean;
  triggerSearch: (searching: boolean) => void;
};

const SearchInput = ({
  handleSearchChange,
  searchValue,
  placeholder,
  isSearching,
  searchIsActive,
  triggerSearch,
}: SearchInputProps) => {
  const clearSearch = () => handleSearchChange('');

  const iconProps = isSearching
    ? {
        rightIcon: (
          <PlusCircle
            onClick={clearSearch}
            dataTestId="close-button"
            className={styles.clearIcon}
          />
        ),
      }
    : {};

  const Icon = () => {
    return (
      <div className={styles.icon}>
        <div className={styles.default}>
          <Search data-id="search-icon" />
        </div>
        <div className={styles.mobile}>
          {searchIsActive ? (
            <ChevronLeft onClick={() => triggerSearch(false)} />
          ) : (
            <Search data-id="search-icon" />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.searchWrapper}>
      <Input
        onMouseDown={() => triggerSearch(true)}
        id="search"
        name="search"
        value={searchValue}
        placeholder={placeholder}
        leftIcon={<Icon />}
        onChange={event => handleSearchChange(event.target.value)}
        autoComplete="off"
        aria-label={placeholder}
        dataTestId="search-input"
        {...iconProps}
        fullWidth
      />
    </div>
  );
};

export default SearchInput;
